import {
  EC2Client,
  DescribeTrafficMirrorSessionsCommand,
  CreateTrafficMirrorSessionCommand,
  DeleteTrafficMirrorSessionCommand,
  ModifyTrafficMirrorSessionCommand,
} from "@aws-sdk/client-ec2";

const fields = [
  {
    variable: "Description",
    hidden: false,
    title: "Session Description",
    field: "Description",
    defaultSort: "asc",
    type: "string",
  },
  {
    variable: "Source",
    hidden: false,
    title: "Mirror Source",
    field: "NetworkInterfaceId",
    defaultSort: "asc",
    type: "string",
  },
  {
    variable: "Target",
    hidden: false,
    title: "Mirror Target",
    field: "TrafficMirrorTargetId",
    defaultSort: "asc",
    type: "string",
  },
  {
    variable: "Filter",
    hidden: false,
    title: "Mirror Filter",
    field: "TrafficMirrorFilterId",
    defaultSort: "asc",
    type: "string",
  },
  {
    variable: "VNI",
    hidden: false,
    title: "VNI",
    field: "VirtualNetworkId",
    defaultSort: "asc",
    type: "number",
  },
];

class SessionService {
  constructor(config) {
    this.searchPlaceholder = "Search Mirror Session";
    this.fields = fields;
    this.config = config;
    this.ec2Client = new EC2Client(this.config);
  }

  getSessions = async (data) => {
    let input = {};
    try {
      if (data && data['traffic-mirror-filter-id']) {
        input = {
          Filters: [{ Name: "traffic-mirror-filter-id", Values: [data['traffic-mirror-filter-id']] }],
          DryRun: false,
        };
      }
      if (data && data['traffic-mirror-target-id']){
        input = {
          Filters: [{ Name: "traffic-mirror-target-id", Values: [data['traffic-mirror-target-id']] }],
          DryRun: false,
        };
      }
      const command = new DescribeTrafficMirrorSessionsCommand(input);
      const response = await this.ec2Client.send(command);
      return response.TrafficMirrorSessions;
    } catch (error) {
      console.error("Error fetching sessions:", error);
      return error;
    }
  };
  
  getSessionById = async (sessionId) => {
    let input = {};
    try {
      if (sessionId) {
        input = { TrafficMirrorSessionIds: [sessionId], DryRun: false };
      }
      const command = new DescribeTrafficMirrorSessionsCommand(input);
      const response = await this.ec2Client.send(command);
      return response.TrafficMirrorSessions;
    } catch (error) {
      console.error("Error fetching filters:", error);
      return error;
    }
  };
  createSession = async (session) => {
    let input = {};
    try {
      if (session) {
        input = { ...session };
        delete input.TrafficMirrorSessionId;
        if (
          input.PacketLength === "" ||
          input.PacketLength == null ||
          input.PacketLength === 0
        ) {
          input.PacketLength = 1540;
        }
        if (input.VirtualNetworkId === "" || input.VirtualNetworkId === 0) {
          delete input.VirtualNetworkId;
        }
      }
      const command = new CreateTrafficMirrorSessionCommand(input);
      const response = await this.ec2Client.send(command);
      return response;
    } catch (error) {
      console.error("Error Creating Session:", error);
      return error;
    }
  };
  deleteSession = async (sessionId) => {
    let input = {};
    try {
      if (sessionId) {
        input = { TrafficMirrorSessionId: sessionId, DryRun: false };
      }
      const command = new DeleteTrafficMirrorSessionCommand(input);
      const response = await this.ec2Client.send(command);
      return response;
    } catch (error) {
      console.error("Error deleting Sesion:", error);
      return error;
    }
  };
  modifySession = async (session) => {
    let input = {};
    let RemoveFields = [];
    let DryRun = false;
    try {
      if (session) {
        input = { ...session };
        if (
          input.PacketLength === "" ||
          input.PacketLength == undefined ||
          input.PacketLength === 0
        ) {
          input.PacketLength = 1540;
        }
        if (input.VirtualNetworkId === "" || input.VirtualNetworkId === 0) {
          RemoveFields.push("virtual-network-id");
          delete input.VirtualNetworkId;
        }
      }
      if (RemoveFields.length > 0) {
        input.RemoveFields = RemoveFields;
      }
      input.DryRun = DryRun;
      const command = new ModifyTrafficMirrorSessionCommand(input);
      const response = await this.ec2Client.send(command);
      return response;
    } catch (error) {
      console.error("Error Modifying session:", error);
      return error;
    }
  };
}

export { SessionService as default, fields as sessionFields };
